import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 2px;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/LocaleToggle/Wrapper.js